import { DUAL_JOINT_LIST_PAGE_TEXT } from './lang';
import { MONITOR_LIST_TEXT } from '../../Assessment/lang';

export const DUAL_JOINT_TABLE_TEXT_MAP = {
  DUAL_PHD_DEGREE_PROGRAMME: DUAL_JOINT_LIST_PAGE_TEXT.DUAL,
  COLLABORATIVE_PHD_DEGREE_PROGRAMME:
    DUAL_JOINT_LIST_PAGE_TEXT.JOint_SUPERVISION,
};

const PROGRAMME_LEVEL = MONITOR_LIST_TEXT.PROGRAMME_LEVEL;
export const getProgrammeTableText = (
  programmeLevel: keyof typeof PROGRAMME_LEVEL,
  programmeType: keyof typeof DUAL_JOINT_TABLE_TEXT_MAP,
): string => {
  const programmeLevelText = PROGRAMME_LEVEL[programmeLevel];
  const programmeTypeText = DUAL_JOINT_TABLE_TEXT_MAP[programmeType];

  let programme = programmeLevelText;
  if (programmeTypeText) {
    programme = `${programmeLevelText} (${programmeTypeText})`;
  }

  return programme;
};
